import { create } from 'zustand';

interface StatusAlertFilter {
  status: boolean | '';
  setStatus: (status: boolean | '') => void;
}

export const statusFilter = create<StatusAlertFilter>((set) => ({
  status: '',
  setStatus: (status) => set({ status }),
}));
